package com.neurobs.ccabserver.transcriptreview.components.errorview

import com.neurobs.ccabserver.transcriptreview.states.ErrorState
import org.scalajs.dom.window
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.web.html.{className, div, i, key, onClick, p}

@react
object ErrorView {

  case class Props()

  val component = FunctionalComponent[Props] {props =>

    val errorState = ErrorState.accessState

		if (errorState.errorStrings.value.isEmpty) div()
		else div(
			errorState.errorStrings.value.zipWithIndex map {item =>
				div(className := "ui negative message")(
					i(className := "close icon", onClick := {() => errorState.removeError(item._2)}),
					p(item._1)
				)
			},
			div(className := "ui divider")
    )
  }
}
